import React, { useState, useCallback, useEffect } from "react";
import { GoogleMap, InfoWindow, Marker, useJsApiLoader } from "@react-google-maps/api";
import { useTranslation } from "react-i18next";
import Phone from "@mui/icons-material/Phone";
import Email from "@mui/icons-material/Email";
import Logo from "assets/images/tawuniya_logo_blue.svg";
import "./style.scss";
import Options from "./Options";

const containerStyle = {
  width: "100%",
  height: "100%",
  borderRadius: "8px",
};

function GoogleMapComp({
  branches = [],
  hospitals = [],
  workShops = [],
  iconClickable = false,
  customMapStyle = containerStyle,
  loggedInUser = false,
  hideOnPropValue,
  editHeight,
}) {

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyCG6PrLZ3iaEeqS6-Akf3HZVJ4chsy6FiM",
  });

  //     // console.log("aaaa", isLoaded);
  const { t } = useTranslation();

  const [map, setMap] = useState(null);
  const [branchInfoCoords, setBranchInfoCoords] = useState({
    lat: null,
    lng: null,
  });
  const [hospitalInfoCoords, setHospitalInfoCoords] = useState({
    lat: null,
    lng: null,
  });
  const [workShopInfoCoords, setWorkShopInfoCoords] = useState({
    lat: null,
    lng: null,
  });
  const [overviewDetails, setOverviewDetails] = useState(null);
  const [userLocation, setUserLocation] = useState({
    lat: 25.352593,
    lng: 49.603326,
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (loggedInUser) {
      const geolocationAPI = navigator.geolocation;
      if (!geolocationAPI) {
        alert("Geolocation API is not available in your browser");
      } else {
        geolocationAPI.getCurrentPosition(
          (position) =>
            setUserLocation({
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            }),
          (error) => alert("Something went wrong getting your positoin.")
        );
      }
    }
  }, []);

  const onLoad = useCallback(function callback(map) {
    // const bounds = new window.google.maps.LatLngBounds(center);
    // map.fitBounds(bounds);
    // setMap(map);
  }, []);

  const onUnmount = useCallback(function callback(map) {
    // setMap(null);
  }, []);

  const handleBranchIconClick = (e, branch) => {
    if (iconClickable) {
      setOpen(true);
      setOverviewDetails(branch);
      setBranchInfoCoords({ lat: e.latLng.lat(), lng: e.latLng.lng() });
    }
  };

  // const handleHospitalIconClick = (e, branch) => {
  // 	if (iconClickable) {
  // 		setOpen(true)
  // 		setOverviewDetails(branch)
  // 		setHospitalInfoCoords({ lat: e.latLng.lat(), lng: e.latLng.lng() });
  // 	}
  // };

  return isLoaded ? (
    <div
      className={`container main-container google-map-container ${editHeight ? "editHeight" : ""}`}
    >
      <GoogleMap
        mapContainerStyle={customMapStyle}
        center={userLocation}
        onLoad={onLoad}
        zoom={12}
        onUnmount={onUnmount}
      >
        {loggedInUser && <Marker position={{ lat: userLocation.lat, lng: userLocation.lng }} />}
        {branches.map((branch, idx) => {
          const lat = branch?.latitudelongitude.split(",")[0];
          const lng = branch?.latitudelongitude.split(",")[1];
          if (lat && lng) {
            return (
              <>
                <Marker
                  key={idx}
                  position={{ lat: lat * 1, lng: lng * 1 }}
                  icon={Logo}
                  onClick={(e) => handleBranchIconClick(e, branch)}
                />
              </>
            );
          }
        })}
      </GoogleMap>
      {hideOnPropValue && hideOnPropValue === "hide" ? null : <Options />}
    </div>
  ) : (
    <></>
  );
}

export default React.memo(GoogleMapComp);
